module.exports = __webpack_public_path__ + "static/media/prix-de-west-2022.77777e80.jpg";